import React, { useState, createRef, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Label,
  Input,
  Button,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Spinner,
  Alert,
  CustomInput,
} from 'reactstrap';
import parse from 'html-react-parser';
import aiva_logo from './../../assets/aiva_logo.png';
import { NavLink } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { postAPI_Onboard, postAPI_EmailCheck } from '../../constants/APIs';
import { Colxx } from '../../components/common/CustomBootstrap';
import StepWizard, { Step } from 'react-step-wizard';
import { Formik, Form, Field } from 'formik';
import Select from 'react-select';
import country from '../../data/country';
import CatgeoryData from './../../data/voucherCategory.json';
import timeZoneList from '../../data/timeZoneList';
import currencyList from '../../data/currencyList';
import { reactSelectOptionDiffrentPro } from '../../helpers/Utils';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import {
  gAPI_Products_List,
  gAPI_Stripe_PromoCode,
} from '../../constants/APIs';
import ProductListItem from './components/ProductListItem';
import ProductListItemCompact from './components/ProductListItemCompact';
import CustomPlan from './components/CustomPlan';
import billingCurrencyList from '../../data/billingCurrencyList';
import { Tooltip } from 'reactstrap';
import AivaProductListItem from './components/AivaProductListItem';

function VoucherSignup() {
  const [formErrors, setFormErrors] = useState({});
  const [propertyNameToolTip, setPropertyNameToolTip] = useState(false);
  const [nameToolTip, setNameToolTip] = useState(false);
  const [emailToolTip, setEmailToolTip] = useState(false);
  const [selectZones, setSelectZones] = useState();
  const [productsList, setProductsList] = useState([]);
  const forms = [createRef(null), createRef(null), createRef(null)];
  const [bottomNavHidden, setBottomNavHidden] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productVisible, setProductVisible] = useState(false);
  const [terms, setTerms] = useState(false);
  const [widthDiv, setwidthDiv] = useState('60%');
  const [buttonText, setButtonText] = useState('Go');
  let [title, settitle] = useState(
    "Welcome to the world of <strong className='aiva-font'>aiva—a</strong> voucher distribution network for savvy tourism businesses!"
  );
  let [subTitle, setSubTitle] = useState(
    'Are you ready to take control of your digital marketing? It’s easy just sign up now.'
  );
  const [propertyData, setpropertyData] = useState({
    name: '',
    website: '',
    type: 'Accommodation',
    country: '',
    timeZone: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    currency: '',
    stripeProductId: '',
    stripePriceId: '',
    address: '',
    productId: 0,
    priceId: 0,
    billingCurrency: '',
    promoId: '',
    promoCode: '',
  });

  const togglePropertyNameToolTip = () => {
    setPropertyNameToolTip(!propertyNameToolTip);
  };
  const toggleNameToolTip = () => {
    setNameToolTip(!nameToolTip);
  };
  const toggleEmailToolTip = () => {
    setEmailToolTip(!emailToolTip);
  };
  const toggle = () => {
    setProductVisible(!productVisible);
  };

  const LoadData = (currency) => {
    AxiosPublicAPI({
      method: 'get',
      url: `${gAPI_Products_List}?currency=${currency}&type=Voucher`,
    })
      .then((res) => {
        setProductsList(res.data);
        const params = new URLSearchParams(window.location.search);
        let product = params.get('product');
        if (product === null) {
          if (res.data.length >= 2) {
            let product = res.data[1];
            setpropertyData({
              ...propertyData,
              stripeProductId: product.productStripeId,
              stripePriceId: product.priceStripeId,
              productId: product.productId,
              priceId: product.pricingId,
            });
            setFormErrors({
              ...formErrors,
              productId: '',
            });
          }
        } else {
          let productArr = res.data.filter(
            (item) => item.productStripeId === product
          );
          if (productArr.length > 0) {
            setpropertyData({
              ...propertyData,
              stripeProductId: productArr[0].productStripeId,
              stripePriceId: productArr[0].priceStripeId,
              productId: productArr[0].productId,
              priceId: productArr[0].pricingId,
            });
            setFormErrors({
              ...formErrors,
              productId: '',
            });
          }
        }
        setLoading(false);
      })
      .catch((err) => null);
  };

  const handleCheckChange = (e) => {
    setTerms(e.target.checked);
  };

  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
    setFormErrors({
      ...formErrors,
      [e.target.name]: '',
    });
  };

  const asyncLoading = () => {
    setLoading(true);
  };

  async function CheckEmail(email) {
    let isValid = true;
    await AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_EmailCheck}`,
      data: {
        email: propertyData.email,
      },
    })
      .then((res) => {
        if (res.data.exists === true) {
          isValid = false;
        }
      })
      .catch((err) => null);
    return isValid;
  }

  const onClickNext = (nextStep, steps, currentStep) => {
    const formIndex = currentStep - 1;
    const form = forms[formIndex].current;
    setFormErrors({});
    form.submitForm().then(async () => {
      let isValid = true;
      let errors = {};
      if (formIndex === 0) {
        if (propertyData.name === '') {
          isValid = false;
          errors.name = 'Please enter property name';
        }
        if (propertyData.website === '') {
          isValid = false;
          errors.website = 'Please enter property website';
        }
        if (propertyData.address === '') {
          isValid = false;
          errors.address = 'Please enter business address';
        }
        if (propertyData.country === '') {
          isValid = false;
          errors.country = 'Please select country';
        }
      }
      if (formIndex === 1) {
        if (propertyData.firstName === '') {
          isValid = false;
          errors.firstName = 'Please enter first name';
        }
        if (propertyData.lastName === '') {
          isValid = false;
          errors.lastName = 'Please enter last name';
        }
        if (propertyData.email === '') {
          isValid = false;
          errors.email = 'Please enter email';
        }
        if (propertyData.phoneNumber === '') {
          isValid = false;
          errors.phoneNumber = 'Please enter phone number';
        }
        if (propertyData.password === '') {
          isValid = false;
          errors.password = 'Please enter password';
        } else if (propertyData.password.length < 6) {
          isValid = false;
          errors.password = 'Password must be longer than 6 characters';
        }
        if (propertyData.confirmPassword === '') {
          isValid = false;
          errors.confirmPassword = 'Please enter confirm password';
        } else if (propertyData.password !== propertyData.confirmPassword) {
          isValid = false;
          errors.confirmPassword = 'Password and confirm password should match';
        }
        if (propertyData.email !== '') {
          if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(propertyData.email)) {
            errors.email = 'Invalid email address';
            isValid = false;
          } else if (!(await CheckEmail(propertyData.email))) {
            isValid = false;
            errors.email = 'Email already registered with us.';
          }
        }
      }
      let couponId = '';
      if (formIndex === 2) {
        if (terms === false) {
          isValid = false;
          errors.terms = 'Please accept the terms and conditions first.';
        }
        if (propertyData.promoCode !== '') {
          await AxiosPublicAPI({
            method: 'get',
            url: `${gAPI_Stripe_PromoCode}?code=${propertyData.promoCode}`,
          }).then((res) => {
            if (res.data.promoCodes.length > 0) {
              couponId = res.data.promoCodes[0].coupon.id;
            } else {
              isValid = false;
              errors.promo = 'Promo code is invalid/expired. Please try again.';
            }
          });
        }
      }
      if (currentStep === 1 && isValid) {
        settitle(
          "Welcome to the world of <strong className='aiva-font'>aiva—a</strong> voucher distribution network for savvy tourism businesses!"
        );
        setSubTitle(
          'Are you ready to take control of your digital marketing? It’s easy just sign up now.'
        );
        setButtonText('Go');
      }
      if (currentStep === 2 && isValid) {
        settitle(
          'Awesome you are a step closer now we just need to get to know you a bit better.'
        );
        setSubTitle('');
        setButtonText('Go');
      }
      if (currentStep === 3 && isValid) {
        settitle('Almost there just hit ‘Good to go’');
        setSubTitle('');
        setButtonText('Good to go!');
      }
      setFormErrors(errors);

      if (isValid) {
        if (formIndex === 0) {
          LoadData(propertyData.currency);
          setwidthDiv('60%');
        } else if (formIndex === 1) {
          setwidthDiv('100%');
        }
        nextStep();
        if (currentStep === 3) {
          setBottomNavHidden(true);
          asyncLoading();
          propertyData.promoId = couponId;
          try {
            let values = window.location.href.substring(
              window.location.href.lastIndexOf('=') + 1,
              window.location.href.length
            );
            if (values !== '') {
              propertyData.data = values;
              propertyData.invitationType = 'SignUp';
              localStorage.removeItem('Invitation');
            }
          } catch {}
          AxiosPublicAPI({
            method: 'post',
            url: `${postAPI_Onboard}`,
            data: propertyData,
          })
            .then((res) => {
              if (res.data.invitationId !== undefined) {
                localStorage.removeItem('Invitation');
                localStorage.setItem('Invitation', res.data.invitationId);
              }
              setLoading(false);
            })
            .catch((err) => null);
        }
      }
    });
  };

  const onClickPrev = (previousStep, steps, currentStep) => {
    if (currentStep === 1) {
      settitle(
        "Welcome to the world of <strong className='aiva-font'>aiva—a</strong> voucher distribution network for savvy tourism businesses!"
      );
      setSubTitle(
        'Are you ready to take control of your digital marketing? It’s easy just sign up now.'
      );
      setButtonText('Go');
    } else if (currentStep === 2) {
      settitle(
        'Awesome you are a step closer now we just need to get to know you a bit better.'
      );
      setSubTitle('');
      setButtonText('Go');
    } else if (currentStep === 3) {
      settitle('Almost there just hit ‘Good to go’');
      setSubTitle('');
      setButtonText('Good to go!');
    }
    setwidthDiv('60%');
    if (currentStep === 1) {
      return;
    }
    previousStep();
  };

  const SelectedProduct = (
    e,
    stripeProductId,
    stripePriceId,
    productId,
    priceId
  ) => {
    if (e.target.tagName !== 'A') {
      setpropertyData({
        ...propertyData,
        stripeProductId: stripeProductId,
        stripePriceId: stripePriceId,
        productId: productId,
        priceId: priceId,
      });
      setFormErrors({
        ...formErrors,
        productId: '',
      });
    }
  };

  const handleChangeSelect = (value, { name }) => {
    setFormErrors({
      ...formErrors,
      country: '',
    });
    let timeZone = '';
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    if (timeZones.length > 0) {
      if (timeZones[0].TimeZones.length === 1) {
        timeZone = timeZones[0].TimeZones[0];
        setSelectZones(
          timeZones[0].TimeZones.map((zone) => {
            return <option value={zone}>{zone}</option>;
          })
        );
      } else {
        timeZone = timeZones[0].TimeZones[0];
        setSelectZones(
          timeZones[0].TimeZones.map((zone) => {
            return <option value={zone}>{zone}</option>;
          })
        );
      }
    }

    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    if (currency.length > 0) {
      let billingCurrencyarr = billingCurrencyList.filter(
        (item) => item.countryCode === value.value
      );
      setpropertyData({
        ...propertyData,
        country: value.value,
        timeZone: timeZone,
        currency: currency[0].currencyCode,
        billingCurrency: billingCurrencyarr[0].currencyCode,
      });
    }
  };

  const NavigationButtons = ({ nextStep, previousStep, currentStep, totalSteps }) => (
    !bottomNavHidden && (
      <div className="mt-4 d-flex justify-content-center">
        <Button
          color="secondary"
          onClick={() => onClickPrev(previousStep, totalSteps, currentStep)}
          disabled={currentStep === 1}
          className="mr-2"
        >
          Back
        </Button>
        <Button
          color="primary"
          onClick={() => onClickNext(nextStep, totalSteps, currentStep)}
          disabled={currentStep === totalSteps}
        >
          {buttonText}
        </Button>
      </div>
    )
  );

  return (
    <Row className="h-100">
      <Colxx xxs="12" md="10" className="mx-auto my-auto">
        <Card className="auth-card">
          <div
            className="form-side wizard wizard-default"
            style={{ padding: '20px', margin: 'auto', width: widthDiv }}
          >
            <div style={{ textAlign: 'center' }}>
              <NavLink to={`/`} className="white">
                <span className="logo-single" style={{ marginBottom: '0px' }}>
                  <img src={aiva_logo} width="300" alt="Aiva Logo" />
                </span>
              </NavLink>
              <CardTitle className="text-center">
                {parse(title)}
              </CardTitle>
              <p className="text-center">{parse(subTitle)}</p>
            </div>
            <StepWizard>
              <Step stepName="step1">
                {({ nextStep, previousStep, currentStep, totalSteps }) => (
                  <div className="wizard-basic-step">
                    <Formik
                      innerRef={forms[0]}
                      initialValues={{}}
                      onSubmit={() => {}}
                    >
                      {({ errors, touched }) => (
                        <Form className="av-tooltip tooltip-label-right rounded">
                          <FormGroup>
                            <Label>
                              Business Name{' '}
                              <i
                                className="demo-icon simple-icon-info"
                                id="propertyNametip"
                              ></i>
                            </Label>
                            <Field
                              className="form-control"
                              name="name"
                              value={propertyData.name}
                              onChange={handleChange}
                            />
                            {formErrors.name && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.name}
                              </div>
                            )}
                            <Tooltip
                              placement="right"
                              isOpen={propertyNameToolTip}
                              target="propertyNametip"
                              toggle={togglePropertyNameToolTip}
                            >
                              If you are group, setup one business, you will be
                              able to add more later on.
                            </Tooltip>
                          </FormGroup>
                          <FormGroup>
                            <Label>Business Website</Label>
                            <Field
                              className="form-control"
                              name="website"
                              value={propertyData.website}
                              onChange={handleChange}
                            />
                            {formErrors.website && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.website}
                              </div>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label>Business Type</Label>
                            <Input
                              className=""
                              type="select"
                              value={propertyData.type}
                              name="type"
                              onChange={handleChange}
                            >
                              {CatgeoryData.data !== undefined &&
                                CatgeoryData.data.map((m, index) => (
                                  <option value={m.value} key={index}>
                                    {m.name}
                                  </option>
                                ))}
                              <option value="Others" key="Others">
                                Others
                              </option>
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label>Business Address</Label>
                            <Field
                              className="form-control"
                              name="address"
                              value={propertyData.address}
                              onChange={handleChange}
                            />
                            {formErrors.address && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.address}
                              </div>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label>Country</Label>
                            <Select
                              isMulti={false}
                              className="react-select"
                              classNamePrefix="react-select"
                              name="code"
                              placeholder="Please Select Country"
                              onChange={handleChangeSelect}
                              options={
                                country
                                  ? reactSelectOptionDiffrentPro(
                                      country,
                                      true,
                                      'code',
                                      'name',
                                      ''
                                    )
                                  : []
                              }
                            />
                            {formErrors.country && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.country}
                              </div>
                            )}
                          </FormGroup>
                          {selectZones !== undefined && selectZones.length > 1 && (
                            <FormGroup>
                              <Label>Time Zone</Label>
                              <Input
                                name="timeZone"
                                type="select"
                                onChange={handleChange}
                                value={propertyData.timeZone}
                              >
                                {selectZones}
                              </Input>
                            </FormGroup>
                          )}
                          <NavigationButtons
                            nextStep={nextStep}
                            previousStep={previousStep}
                            currentStep={currentStep}
                            totalSteps={totalSteps}
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                )}
              </Step>
              <Step stepName="step2">
                {({ nextStep, previousStep, currentStep, totalSteps }) => (
                  <div className="wizard-basic-step">
                    <Formik
                      innerRef={forms[1]}
                      initialValues={{}}
                      onSubmit={() => {}}
                    >
                      {({ errors, touched }) => (
                        <Form className="av-tooltip tooltip-label-right rounded">
                          <FormGroup>
                            <Label>
                              First Name{' '}
                              <i
                                className="demo-icon simple-icon-info"
                                id="nametip"
                              ></i>
                            </Label>
                            <Field
                              className="form-control"
                              name="firstName"
                              value={propertyData.firstName}
                              onChange={handleChange}
                            />
                            {formErrors.firstName && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.firstName}
                              </div>
                            )}
                            <Tooltip
                              placement="right"
                              isOpen={nameToolTip}
                              target="nametip"
                              toggle={toggleNameToolTip}
                            >
                              This is your first user account, and you will be
                              able to add your team members later on.
                            </Tooltip>
                          </FormGroup>
                          <FormGroup>
                            <Label>Last Name</Label>
                            <Field
                              className="form-control"
                              name="lastName"
                              value={propertyData.lastName}
                              onChange={handleChange}
                            />
                            {formErrors.lastName && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.lastName}
                              </div>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label>
                              Business Email{' '}
                              <i
                                className="demo-icon simple-icon-info"
                                id="emailtip"
                              ></i>
                            </Label>
                            <Field
                              className="form-control"
                              name="email"
                              value={propertyData.email}
                              onChange={handleChange}
                            />
                            {formErrors.email && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.email}
                              </div>
                            )}
                            <Tooltip
                              placement="right"
                              isOpen={emailToolTip}
                              target="emailtip"
                              toggle={toggleEmailToolTip}
                            >
                              Your first account will be created with this email
                              address.
                            </Tooltip>
                          </FormGroup>
                          <FormGroup>
                            <Label>Phone Number</Label>
                            <Field
                              className="form-control"
                              name="phoneNumber"
                              value={propertyData.phoneNumber}
                              onChange={handleChange}
                            />
                            {formErrors.phoneNumber && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.phoneNumber}
                              </div>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label>Password</Label>
                            <Field
                              className="form-control"
                              type="password"
                              name="password"
                              value={propertyData.password}
                              onChange={handleChange}
                            />
                            {formErrors.password && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.password}
                              </div>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label>Confirm Password</Label>
                            <Field
                              className="form-control"
                              type="password"
                              name="confirmPassword"
                              value={propertyData.confirmPassword}
                              onChange={handleChange}
                            />
                            {formErrors.confirmPassword && (
                              <div className="invalid-feedback aiva-border d-block">
                                {formErrors.confirmPassword}
                              </div>
                            )}
                          </FormGroup>
                          <NavigationButtons
                            nextStep={nextStep}
                            previousStep={previousStep}
                            currentStep={currentStep}
                            totalSteps={totalSteps}
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                )}
              </Step>
              <Step stepName="step3">
                {({ nextStep, previousStep, currentStep, totalSteps }) => (
                  <div className="wizard-basic-step">
                    <Formik
                      innerRef={forms[2]}
                      initialValues={{}}
                      onSubmit={() => {}}
                    >
                      {({ errors, touched }) => (
                        <Form className="av-tooltip tooltip-label-right rounded">
                          <div
                            className="equal-height-container row"
                            style={{ marginLeft: '20%', marginRight: '20%' }}
                          >
                            <AivaProductListItem
                              key={`product_item_`}
                              toggle={toggle}
                              SelectedProduct={SelectedProduct}
                              SelectedProductID={propertyData.stripeProductId}
                              w={4}
                              voucher={true}
                            />
                          </div>
                          {formErrors.productId && (
                            <Alert color="danger" className="rounded">
                              {formErrors.productId}
                            </Alert>
                          )}
                          {formErrors.terms && (
                            <Alert color="danger" className="rounded">
                              {formErrors.terms}
                            </Alert>
                          )}
                          {formErrors.promo && (
                            <Alert color="danger" className="rounded">
                              {formErrors.promo}
                            </Alert>
                          )}
                          <div className="mt-3" style={{ textAlign: 'center' }}>
                            <CustomInput
                              type="checkbox"
                              id="chkTerms"
                              checked={terms}
                              onChange={handleCheckChange}
                              name="terms"
                              label={
                                <label>
                                  I agree to aiva{' '}
                                  <a
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://www.myma.ai/terms"
                                    style={{ textDecoration: 'underline' }}
                                  >
                                    Merchant Terms and Conditions
                                  </a>
                                </label>
                              }
                            />
                          </div>
                          <div className="row text-center mb-3">
                            <div className="col-xs-4"></div>
                            <div className="col-xs-4">
                              <Field
                                className="form-control"
                                type="text"
                                name="promoCode"
                                value={propertyData.promoCode}
                                placeholder="Apply Promo Code"
                                onChange={handleChange}
                                style={{ width: '150px' }}
                              />
                            </div>
                            <div className="col-xs-4"></div>
                          </div>
                          <Fragment>
                            <Modal
                              isOpen={productVisible}
                              toggle={toggle}
                              size="lg"
                              style={{ maxWidth: '1024px' }}
                            >
                              <ModalHeader toggle={toggle}>
                                Packages
                              </ModalHeader>
                              <ModalBody>
                                <div className="equal-height-container mb-5 row">
                                  <AivaProductListItem
                                    key={`product_item`}
                                    SelectedProduct={SelectedProduct}
                                    SelectedProductID={propertyData.stripeProductId}
                                    w={4}
                                    voucher={true}
                                  />
                                </div>
                              </ModalBody>
                              <ModalFooter>
                                <Button color="secondary" onClick={toggle}>
                                  Close
                                </Button>
                              </ModalFooter>
                            </Modal>
                          </Fragment>
                          <NavigationButtons
                            nextStep={nextStep}
                            previousStep={previousStep}
                            currentStep={currentStep}
                            totalSteps={totalSteps}
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                )}
              </Step>
              <Step stepName="step4">
                {({ nextStep, previousStep, currentStep, totalSteps }) => (
                  <div className="wizard-basic-step text-center pt-3">
                    {loading ? (
                      <div>
                        <Spinner color="primary" className="mb-1" />
                        <p>Your request is in progress</p>
                      </div>
                    ) : (
                      <div>
                        <h2 className="mb-2">Thank You!</h2>
                        <p>
                          Your registration completed successfully! Once
                          verified, you will get notified via email.
                        </p>
                      </div>
                    )}
                    <NavigationButtons
                      nextStep={nextStep}
                      previousStep={previousStep}
                      currentStep={currentStep}
                      totalSteps={totalSteps}
                    />
                  </div>
                )}
              </Step>
            </StepWizard>
          </div>
        </Card>
      </Colxx>
    </Row>
  );
}

export default injectIntl(VoucherSignup);